module.exports = __webpack_public_path__ + "static/img/14001024.185501d9.png";